import React from 'react';
import { Modal } from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner';

/*  This NPSpinnerModal only toggle hide/show from 
 *  parent component, to remove the locked situation.
 *  The previous version needs to call a parental refresh
 *  in order to reset the local state showModal to "true",
 *  in order to re-use the component.
 *  This one does not rely on the parent refresh to be 
 *  re-useable.
 */

class NPSpinnerModalBetter extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {
        const { showModal = false, isLoading = false, content, title, closeAction } = this.props;

        return (
            <Modal show={showModal} onHide={() => { closeAction && closeAction(); }}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                    {!isLoading && content}
                    {isLoading && <LoadingSpinner isLoading={true} />}
                </Modal.Body>
            </Modal>
        )
    }
}

export default NPSpinnerModalBetter;